import React, { useEffect, useRef, useState } from 'react';
import bellImg from '@images/bellImg.png';
import successImg from '@images/succusImg.png';
import './ToastTile.css';

const imageMap = {
	error: bellImg,
	suc: successImg,
};
const ToastTitle = ({ type, toastText }) => (
	<div className={`toastTile ${type}`}>
		<img src={imageMap[type]} alt="toast" />
		<div>{toastText}</div>
	</div>
);

export const ToastMsg = ({ message, onClose, toastFor }) => {
	const [textVisibile, setTextVisibility] = useState(false);
	const counterRef = useRef(null);

	useEffect(() => {
		setTextVisibility(true);
		counterRef.current = setTimeout(() => {
			setTextVisibility(false);
			onClose?.();
		}, 6000);
		return () => {
			clearTimeout(counterRef.current);
			onClose?.();
		};
	}, [message]);
	return (
		<>
			{textVisibile && (
				<div className={`toastMsg ${toastFor ? 'toastMsgMultiSelect' : ''}`}>
					<span>{message}</span>
				</div>
			)}
		</>
	);
};

export default ToastTitle;
